import { Create } from '@fund/api-modules';
import CreateByUser from './decorator/CreateByUser';
import NewsModel from '../model/news.model';
import PublicNewsListModel from '../model/public-news-list.model';
import TransformResponse from './decorator/TransformResponse';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  // baseURL: 'https://np-fundlist.eastmoney.com/fund', // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  baseURL: 'https://np-listapi-uat.eastmoney.com/fund',
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class EMNewApi {
  @TransformResponse((res) => NewsModel.objectArrayWithKeyValuesArray(res.data.news || []))
  getNewlist(FCODE) {
    const code = `150.${FCODE}`;
    return this.POST('/getFundSelfNews', {
      biz: 'fund_app_self_news',
      client: 'fund_app',
      client_version: '1.0.0',
      deviceId: '111',
      needInteractData: 1,
      np_type: [
        'cms',
      ],
      order: 2,
      page_size: 2,
      req_trace: 20,
      requestData: [
        code,
      ],
      sortEnd: '',
    });
  }

  @TransformResponse((res) => PublicNewsListModel.objectWithKeyValues(res.data || {}))
  getNewsList(FCODE) {
    const code = `150.${FCODE}`;
    return this.POST('/getFundSelfNews', {
      biz: 'fund_app_self_news',
      client: 'fund_app',
      client_version: '1.0.0',
      deviceId: '111',
      needInteractData: 1,
      np_type: [
        'cms',
      ],
      order: 2,
      page_size: 2,
      req_trace: 20,
      requestData: [
        code,
      ],
      sortEnd: '',
    });
  }
}
export default new EMNewApi();
